export default __webpack_public_path__ + "static/media/ecash-circle.c384df58.png";